import React, { useEffect } from "react";
import { gql } from "@apollo/client";
import { basename } from "env";
import { resetAccount } from "@repoflow/components/account";
import { Icon as LoadingIcon } from "@repoflow/components/loading";
import { useMutation } from "@apollo/client";
import { Container, Col, Row, Alert } from "reactstrap";

const MUTATION = gql`
  mutation Logout {
    viewer {
      account {
        auth {
          logout
        }
      }
    }
  }
`;

export default () => {
  const [handler, { error }] = useMutation(MUTATION, {
    refetchQueries: [],
    onCompleted: () => {
      resetAccount();
      // This app's own sign-in landing, which sends you on to the auth domain
      // with the right domainId. It used to point at `${basename}/auth/login`,
      // a route this app does not have — it only worked because the prefix
      // match fell through to the same page.
      window.location = `${basename}/auth/home`;
    },
    // The session cookie is cleared by the server, so a failed mutation means
    // you are still signed in. Say so rather than sending you to a sign-in
    // page that would put you straight back where you were.
    onError: (error) => {
      console.error("account.logout:", error);
    },
  });

  useEffect(() => {
    handler();
  }, []);

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          {error ? (
            <Alert color="danger">
              You could not be signed out. Please check your connection and{" "}
              <button
                type="button"
                className="btn btn-link p-0 align-baseline"
                onClick={() => handler()}
              >
                try again
              </button>
              .
            </Alert>
          ) : (
            <Alert color="info">
              Signing you out... <LoadingIcon />
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
};
